module.exports = __webpack_public_path__ + "img/fire_al.51730c31.svg";